import { z } from 'zod';

export const PermissionsSchema = z.object({
  lessonly: z.boolean(),
  seismic: z.boolean(),
  workday: z.boolean(),
  myApps: z.boolean(),
});

export type Permissions = z.infer<typeof PermissionsSchema>;
